import { PAGE_CACHE_TAGS } from '~/config/index';

const { HTML_PREFIX: CACHE_PREFIX, HTML: HTML_TAGS_ARRAY } = PAGE_CACHE_TAGS;

export default function (tags = []) {
    const tagsWithPrefix = tags.map(tag => `${CACHE_PREFIX}-${tag}`);
    return [...HTML_TAGS_ARRAY, ...tagsWithPrefix].join(',');
}
